<template>
  <div>
    <recipient v-if="schema.recipient" :model="schema.recipient" />

    <jst-picker :model="schema.jst" :terc-for-autocomplete="terc" @change="clearTexts" />

    <w-select class="mt-2" :values="RecipientPositionList" :model="schema.position" @input="clearTexts" />

    <div v-if="!!schema.decision" class="mt-2">
      <w-wysiwyg :model="schema.decision" :config="decisionConfig" />
    </div>

    <div v-if="!!schema.judgment" class="mt-2">
      <w-wysiwyg :model="schema.judgment" :config="judgmentConfig" />
    </div>

    <div v-if="!!schema.reason" class="mt-2">
      <w-wysiwyg :model="schema.reason" :config="reasonConfig" />
    </div>

    <div v-if="!!schema.recivers" class="mt-2">
      <w-wysiwyg :model="schema.recivers" :config="toInformConfig" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import JstPicker from '@/components/formComponents/JstPicker';
import { RecipientPositionList } from '@/enums/recipientPosition.enum';

import Recipient from './components/Recipient';

// @vuese
// Formularz uzasadnienia
// @group ActionData
export default {
  components: { ...components, JstPicker, Recipient },
  props: {
    // schema
    schema: { type: Object, required: true },
    // Dane zewnętrzne
    external: { type: Object, required: true }
  },
  data() {
    return {
      // Konfiguracja decyzji
      decisionConfig: { allowedContent: true, height: 150 },

      // Konfiguracja orzeczeń
      judgmentConfig: { allowedContent: true, height: 150 },

      // Konfiguracja uzasadnień
      reasonConfig: { allowedContent: true, height: 150 },

      // Konfiguracja sekcji "otrzymują"
      toInformConfig: { allowedContent: true, height: 100 },

      RecipientPositionList
    };
  },

  computed: {
    terc() {
      if (this.external?.document?.data?.applicant?.address?.terc?.length >= 6) {
        return this.external?.document?.data?.applicant?.address?.terc?.slice(0, 6);
      }
    }
  },

  watch: {
    'schema.attachmentIds.$value.length'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearRecivers();
      }
    }
  },

  methods: {
    // @vuese
    // Czyści teksty zależne od jednostki/osoby kierującej jednostką
    clearTexts() {
      this.schema.judgment.$setDefault();
    },

    // @vuese
    // Czyści wartość pola `recivers` (załączniki)
    clearRecivers() {
      this.schema.recivers.$setDefault();
    }
  }
};
</script>
